// MainMenu.js

import React from "react";
import { useEffect, useState } from "react";
import { Pressable, Text, View } from "react-native";
import { Feather } from "@react-native-vector-icons/feather";  // https://feathericons.com/?query=
import appviews from "components/helpers/appviews";

const MainMenu = function () {
	const _theme = window.main.theme;

	const [openState, setOpenState] = useState(false);
	const currentViewKey = (window.main.lib.getCurrentView());
	const toggleMenu = ()=>{
		setOpenState(s=>(!s));
	};
	// const toggleDarkMode = ()=>{
	// 	window.main.lib.setScreenState({ currentDarkTheme: !window.main.lib.screenState.currentDarkTheme });
	// 	setOpenState(false);
	// };

	const sharedStyles = {
		menuContainer: {
			alignItems: "flex-start",
			backgroundColor: _theme.colors.mode.menuBackgroundColor,
			borderBottomLeftRadius: 14,
			borderBottomWidth: 1,
			borderColor: _theme.colors.light.menuBorderColor,
			borderLeftWidth: 1,
			borderRightWidth: 0,
			borderTopLeftRadius: 14,
			borderTopWidth: 1,
			boxShadow: "-2px 3px 7px -2px #00000077",
			display: "flex",
			flexDirection: "column",
			fontSize: 0,
			justifyContent: "stretch",
			lineHeight: 0,
			overflow: "hidden",
			minWidth: (window.main.platform_os==="web"?48:42),  // When Menu is CLOSED, this sets the right-side spacing of the menu icon
		},
		menuTitleRow: {
			borderBottomWidth: (!!openState?1:0),
			borderTopWidth: 0,
			height: 40,
			paddingLeft: 10,
			paddingRight: 12,  // When Menu is CLOSED, this sets the right-side spacing of the menu icon
		},
		menuTitleRowIcon: {
			color: _theme.colors.mode.menuTextColor,
			fontSize: 22,
			height: 24,
			lineHeight: 26,
		},
		menuTitleRowText: {
			fontWeight: "600",
			fontSize: 20,
			marginRight: 40,
		},
		menuRow: {
			alignItems: "center",
			alignSelf: "stretch",
			borderColor: _theme.colors.mode.menuBorderColor,
			borderTopWidth: 1,
			color: _theme.colors.mode.menuTextColor,
			display: "flex",
			flexDirection: "row",
			height: 36,
			justifyContent: "stretch",
			lineHeight: 36,
			paddingBottom: 0,
			paddingLeft: 12,
			paddingRight: 40,
			paddingTop: 0,
			whitespace: "no-wrap",
		},
		menuRowIcon: {
			color: _theme.colors.mode.menuTextColor,
			fontSize: 18,
			lineHeight: 20,
			height: 20,
			width: 20,
		},
		menuRowText: {
			color: _theme.colors.mode.menuTextColor,
			fontSize: 16,
			lineHeight: 36,
			marginLeft: 15,
		},
	};

	useEffect(()=>{
		// Simply having this here causes the component to refresh and that allows 'process.env.REACT_APP_APPTITLE' to display its correct value.
	},[]);

	return (
		<View style={{...sharedStyles.menuContainer,...(!openState?{boxShadow:"none",borderBottomWidth:0,borderLeftWidth:0,borderTopWidth:0,backgroundColor:_theme.colors.mode.backgroundColor}:{})}}>
			<Pressable style={{...sharedStyles.menuRow,...sharedStyles.menuTitleRow}} onPress={toggleMenu}>
				<Feather name="menu" style={{...sharedStyles.menuRowIcon,...sharedStyles.menuTitleRowIcon}} />
				{!!openState &&
					<>
						<Text style={{...sharedStyles.menuRowText,...sharedStyles.menuTitleRowText}}>
							Main Menu
						</Text>
						<Feather name="x" style={{...sharedStyles.menuRowIcon,...sharedStyles.menuTitleRowIcon, position:"absolute", right:(window.main.platform_os==="web"?14:9), top:(window.main.platform_os==="web"?8:8), fontSize:sharedStyles.menuTitleRowIcon.fontSize+4,width:25}} />
					</>
				}
			</Pressable>
			{!!openState && appviews.mainMenuKeys.map((linkKey)=>{
				const _menuLinkObj = appviews[linkKey];
				const _menuLinkOnClick = ()=>{
					if (!!_menuLinkObj.function) {
						_menuLinkObj.function();
					} else {
						window.main.lib.setCurrentView(linkKey);
					}
					setOpenState(false);
				};
				return (
					<Pressable key={linkKey} style={{...sharedStyles.menuRow}} onPress={_menuLinkOnClick}>
						<Feather name={_menuLinkObj.icon} size={20} style={{...sharedStyles.menuRowIcon,...(_menuLinkObj.icon==="log-out"?{transform:[{rotate:"180deg"}],marginLeft:-3,marginRight:3}:null)}} />
						<Text style={sharedStyles.menuRowText}>
							{_menuLinkObj.title}
						</Text>
					</Pressable>
				);
			})}
			{/* {!!openState &&
				<Pressable style={{...sharedStyles.menuRow}} onPress={toggleDarkMode}>
					<Feather name={!!window.main.lib.screenState.currentDarkTheme?"moon":"sun"} style={{...sharedStyles.menuRowIcon}} />
					<Text style={sharedStyles.menuRowText}>
						Toggle Darkmode {!!window.main.lib.screenState.currentDarkTheme?"Off":"On"}
					</Text>
				</Pressable>
			} */}
		</View>
	);
};

export default MainMenu;
